<!--
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2020-03-04 13:29:20
 -->
<template>
  <div>
    <div class="text">
      <span>{{ text }}</span>
    </div>
    <div>
      <el-button @click="confirm">{{ buttonTitle }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    buttonTitle: {
      type: String,
      default: '确认'
    }
  },
  methods: {
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.text {
  padding: 77px 40px;
  span {
    text-align: center;
    font-size: 20px;
    font-family: STXihei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
  }
}
.el-button {
  width: 100%;
  height: 40px;
  background: #c12b20;
  color: white;
  border-radius: 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorAlertView.vue